export const searchList = {
    breadcrumbName: 'Search Result',
    sidebar: {
        searchDetail: 'หมวดหมู่',
        radioCategory: {
            name: '',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        lowPrice: {
            name: 'ราคา น้อย ไป มาก',
            placeholder: 'ราคา น้อย ไป มาก',
            required: 'กรุณากรอกราคาต่ำสุด',
            too_short: '',
            invalid: '',
            currency: '฿'
        },
        highPrice: {
            name: 'ราคา มาก ไป น้อย',
            placeholder: 'ราคา มาก ไป น้อย',
            required: 'กรุณากรอกราคาสูงสุด',
            too_short: '',
            invalid: '',
            currency: '฿'
        },
        // radioCategory: [
        //     { text: 'บรรจุภัณฑ์', value: 'packaging'},
        //     { text: 'อาหาร', value: 'food'},
        //     { text: 'เครื่องดื่ม', value: 'drink'},
        //     { text: 'ของใช้ในบ้าน', value: 'in-house'},
        //     { text: 'สินค้าแม่และเด็ก', value: 'for-mom-and-kid'},
        //     { text: 'เครื่องเขียน', value: 'stationery'},
        //     {
        //         text: 'เครื่องใช้ไฟฟ้า',
        //         subItems: [
        //             { text: 'ห้องน้ำ', value: 'bathroom'},
        //             { text: 'ห้องครัว', value: 'kitchen'},
        //             { text: 'ห้องนอน', value: 'bedroom'},
        //             { text: 'ห้องนั่งเล่น', value: 'living-room'},
        //             { text: 'อื่นๆ', value: 'other'},
        //         ]
        //     },
        // ],
        range: 'ช่วงราคา',
        agency: 'ค้นหาตามแบรนด์',
        radioBrand: [
            { text: 'No Brand', value: null},
            { text: 'Dnee', value: 'dnee'},
            { text: 'Breeze', value: 'breeze'},
            { text: 'Downy', value: 'downy'},
            { text: 'Giffarine', value: 'giffarine'},
            { text: 'Fineline', value: 'fineline'},
            { text: 'Essense', value: 'essense'},
            { text: 'Pao', value: 'pao'},
        ],
        showMore: 'แสดงเพิ่มเติม'
    },
    searchBy: 'ผลการค้นหาสำหรับ',
    clearSearch : 'ล้างข้อมูล',
    orderBy : 'การจัดเรียง',
    mayLike: 'รายการสินค้าใกล้เคียง',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    sort_lowPrice: 'ราคา น้อย ไป มาก',
    sort_highPrice: 'ราคา มาก ไป น้อย',
    sort_recommen: 'สินค้าแนะนำ',
    nodata: 'ไม่พบสินค้าที่ค้นหา',
}
